import { apiFetch } from './apiClient';

const cache: Record<string, any> = {};

export async function fetchGameFile(gamesPath: string): Promise<any> {
  if (cache[gamesPath]) return cache[gamesPath];

  const res = await apiFetch(`/api/games/by-path?path=${encodeURIComponent(gamesPath)}`);

  if (!res.ok) throw new Error(`Failed to load game file: ${gamesPath} (${res.status})`);

  const row = await res.json();
  cache[gamesPath] = row.data;
  return row.data;
}

export function clearGameDataCache(): void {
  Object.keys(cache).forEach(k => delete cache[k]);
}
